import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cubaimg from "../../assets/images/logo/logo-icon.png";
import egaollogo from "../../assets/images/logo/EGoal-favcon.png";
import CustomizerContext from '../../_helper/Customizer';

const SidebarIcon = () => {
  const { layoutURL } = useContext(CustomizerContext);
  return (
    <div className="logo-icon-wrapper">
      {/* <Link to={`${process.env.PUBLIC_URL}/dashboard/default/${layoutURL}`}> */}
      <Link>
        <img
          className="img-fluid"
          src={egaollogo}
          alt=""
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;